import style from './DateSelect.module.css'

import classNames from 'classnames/bind'
import { useState, useRef } from 'react'
import useTranslation from 'next-translate/useTranslation'

const getDaysInMonth = (year, month) => year > 0 && month > 0 ? new Date(year, month, 0, 0, 0, 0, 0).getDate() : 31

export default function Notification ({ onChange, required, disabled, defaultValue, locale, inTheFuture }) {
  const c = classNames.bind(style)
  const { t } = useTranslation('main')

  const yearElem = useRef()
  const monthElem = useRef()
  const dayElem = useRef()

  const currentYear = new Date().getFullYear()
  const fromYear = inTheFuture ? currentYear : currentYear - 125
  const toYear = inTheFuture ? currentYear + 20 : currentYear

  let valueYear
  let valueMonth
  let valueDay
  if (typeof defaultValue === 'string' && defaultValue?.length >= 4) {
    const values = defaultValue.substring(0, 10).split('-')
    valueYear = parseInt(values[0], 10)
    valueMonth = parseInt(values[1], 10)
    valueDay = parseInt(values[2], 10)
  }

  const [year, setYear] = useState(valueYear >= fromYear && valueYear <= toYear ? valueYear : '')
  const [month, setMonth] = useState(valueMonth > 0 && valueMonth <= 12 ? valueMonth : '')
  const [daysInMonth, setDaysInMonth] = useState(getDaysInMonth(year, month))
  const [day, setDay] = useState(valueDay > 0 && valueDay <= daysInMonth ? valueDay : '')

  const years = []
  if (inTheFuture) {
    for (let i = fromYear; i <= toYear; i++) {
      years.push(i)
    }
  } else {
    for (let i = toYear; i >= fromYear; i--) {
      years.push(i)
    }
  }

  const months = []
  for (let i = 1; i <= 12; i++) {
    months.push(i)
  }

  const days = []
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i)
  }

  const handleChange = () => {
    const y = parseInt(yearElem.current.value, 10) || ''
    const m = parseInt(monthElem.current.value, 10) || ''
    let d = parseInt(dayElem.current.value, 10) || ''
    const dim = getDaysInMonth(y, m)
    if (d && d > dim) {
      d = 1
    }
    setYear(y)
    setMonth(m)
    setDay(d)
    setDaysInMonth(dim)
    if (y && m && d) {
      const value = `${y}-${m < 10 ? '0' + m : m}-${d < 10 ? '0' + d : d}`
      onChange({
        target: {
          value,
          setCustomValidity: str => {
            yearElem.current.setCustomValidity(str)
            monthElem.current.setCustomValidity(str)
            dayElem.current.setCustomValidity(str)
          }
        }
      })
    }
  }

  return (
    <div className={c('container')}>
      <select ref={yearElem} value={year} className={c('year', { empty: !valueYear && !required })} required={required} disabled={disabled} onChange={handleChange}>
        <option disabled value=''>{t('year')}</option>
        {years.map(y => <option key={y} value={y}>{y}</option>)}
      </select>
      <select ref={monthElem} value={month} className={c('month', { empty: !valueMonth && !required })} required={required} disabled={disabled} onChange={handleChange}>
        <option disabled value=''>{t('month')}</option>
        {months.map(m => <option key={m} value={m}>{new Date(year, m - 1, 1, 0, 0, 0, 0).toLocaleDateString(locale, { month: 'short' })}</option>)}
      </select>
      <select ref={dayElem} value={day} className={c('day', { empty: !valueDay && !required })} required={required} disabled={disabled} onChange={handleChange}>
        <option disabled value=''>{t('day')}</option>
        {days.map(d => <option key={d} value={d}>{d}</option>)}
      </select>
    </div>
  )
}
